// PHASE 1: What frustrates you most about your current space?
import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSearchParams, useSubmit } from 'react-router-dom'
import useUpdateMode from '../../../hooks/useUpdateMode'
import { saveAnswer } from '../../../utils/onboardingStorage'

const QUESTION_KEY = 'spaceFrustration'

const OPTIONS = [
  {
    value: 'Feels cluttered and chaotic',
    translationKey: 'pages.onboarding.v2.spaceFrustration.options.cluttered',
    emoji: '📦',
  },
  {
    value: 'Looks outdated or boring',
    translationKey: 'pages.onboarding.v2.spaceFrustration.options.outdated',
    emoji: '😴',
  },
  {
    value: "Doesn't reflect who I am",
    translationKey: 'pages.onboarding.v2.spaceFrustration.options.identity',
    emoji: '🪞',
  },
  {
    value: 'Never feels quite comfortable',
    translationKey:
      'pages.onboarding.v2.spaceFrustration.options.uncomfortable',
    emoji: '😣',
  },
  {
    value: "Can't find the right pieces",
    translationKey: 'pages.onboarding.v2.spaceFrustration.options.pieces',
    emoji: '🧩',
  },
  {
    value: 'Overwhelmed by options',
    translationKey: 'pages.onboarding.v2.spaceFrustration.options.overwhelmed',
    emoji: '🤯',
  },
]

export default function SpaceFrustrationPage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && OPTIONS.some((option) => option.value === value)
      ? value
      : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const value = formData.get('answer') as string

    if (!value) return

    const answer = {
      question_key: QUESTION_KEY,
      question: 'What frustrates you most about your current space?',
      answer_key: value,
      answer: value,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(event.currentTarget)
    }
  }

  const buttons = OPTIONS.map((option) => ({
    text: `${option.emoji} ${t(option.translationKey)}`,
    value: option.value,
  }))

  return (
    <QuestionPage
      heading={t('pages.onboarding.v2.spaceFrustration.heading')}
      buttons={buttons}
      onSubmit={handleSubmit}
      headingSize="text-3xl text-center whitespace-pre-line"
      buttonTextSize="text-xl"
      buttonBgColor="bg-white"
      preselectedValue={preselectedValue}
    />
  )
}
